module.exports = __webpack_public_path__ + "img/aval.42a72264.png";